module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    class: {
      'long': _vm.long
    }
  }, [_c('div', {
    staticClass: "chart-container",
    class: {
      'long1': _vm.long
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.styleText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('logRe')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.timeRange))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.pump_device))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))]), _vm._v(" "), _c('td', {
    staticClass: "td td4"
  }, [_vm._v(_vm._s(_vm.$t('HbA1c')))]), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.hb1c[0]))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "tip",
    class: {
      'po6': _vm.isPo, 'fr6': _vm.isFr
    }
  }, [_c('span', {
    attrs: {
      "id": "m0"
    }
  }, [_vm._v(_vm._s(_vm.$t('Breakfast')))]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "m1"
    }
  }, [_vm._v(_vm._s(_vm.$t('Lunch')))]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "m2"
    }
  }, [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _vm._l((_vm.pagePos), function(base, p) {
    return _c('div', [(p == 1) ? _c('div', [_c('div', {
      staticClass: "page-seperator"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "main-wrapper table-wrapper",
      attrs: {
        "id": "table-wrapper"
      }
    }, [_c('table', {
      staticClass: "table content"
    }, [_c('tr', [_c('td', {
      staticClass: "title",
      staticStyle: {
        "width": "60px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _c('td', {
      staticStyle: {
        "width": "127px",
        "border-right": "none"
      }
    }, [_vm._v(_vm._s(_vm.$t('dailyTotal')))]), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "spe7"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "spe10"
    }, [_vm._v("23:00")])], 2)]), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + _vm.perPage[p])), function(item, index) {
      return _c('table', {
        staticClass: "table content",
        class: {
          'po4': _vm.isPo || _vm.isDu || _vm.isDe || _vm.isIt || _vm.isFr || _vm.isSw
        },
        attrs: {
          "id": base + index
        }
      }, [_c('tr', [_c('td', {
        staticClass: "spe5",
        staticStyle: {
          "width": "60px"
        },
        attrs: {
          "rowspan": "4"
        }
      }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('td', {
        staticClass: "spe1 spe5",
        staticStyle: {
          "width": "45px"
        }
      }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _vm._v(" "), _c('td', {
        staticClass: "spe1 spe5",
        staticStyle: {
          "width": "85px"
        }
      }, [_vm._v(_vm._s(_vm.bgAvg[base + index].avg))]), _vm._v(" "), _vm._l((23), function(n) {
        return _c('td', {
          staticClass: "spe1 spe5"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "spe4 spe1"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "spe"
      }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _c('td', {
        staticClass: "spe"
      }, [_vm._v(_vm._s(_vm.carb[base + index].total))]), _vm._v(" "), _vm._l((23), function(n) {
        return _c('td', {
          staticClass: "spe"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "spe4 spe1"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "spe"
      }, [_vm._v(_vm._s(_vm.$t('insulin')))]), _vm._v(" "), _c('td', {
        staticClass: "spe"
      }, [_vm._v(_vm._s(_vm.ins[base + index].total) + " " + _vm._s(_vm.$t('bolus')) + ":" + _vm._s(_vm.ins[base + index].percent) + " %")]), _vm._v(" "), _vm._l((23), function(n) {
        return _c('td', {
          staticClass: "spe"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "spe4 spe1"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "spe6"
      }, [_vm._v(_vm._s(_vm.$t('events')))]), _c('td', {
        staticClass: "spe6"
      }), _vm._v(" "), _vm._l((23), function(n) {
        return _c('td', {
          staticClass: "spe6"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "spe4"
      })], 2)])
    })], 2)])
  }), _vm._v(" "), (_vm.chartEndPage.show) ? _c('div', [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'zh8': !_vm.isEn, 'de8': _vm.isDe, 'it8': _vm.isIt, 'po8': _vm.isPo, 'du8': _vm.isDu, 'fr8': _vm.isFr || _vm.isCz, 'sw8': _vm.isSw
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": require("../../assets/chart5-icon/High Patch.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('High Glucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": require("../../assets/chart5-icon/low Glucose.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Low Glucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": require("../../assets/chart5-icon/middle Glucose.jpg")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1112_Normal_Glucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": require("../../assets/chart5-icon/No Active Patch.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('No Active Patch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": require("../../assets/chart5-icon/Manual Suspend.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": require("../../assets/chart5-icon/Auto Suspend.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh9': !_vm.isEn
    }
  }, [_c('img', {
    staticClass: "img-spe1",
    attrs: {
      "src": require("../../assets/chart5-icon/Missed Meal.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Missed Meal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe2",
    class: {
      'zh10': !_vm.isEn, 'it10': _vm.isIt, 'po10': _vm.isPo, 'du10': _vm.isDu, 'cz10': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/chart5-icon/Stop Patch .png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Stop Patch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe3",
    class: {
      'it11': _vm.isIt, 'po11': _vm.isPo, 'du11': _vm.isDu, 'cz11': _vm.isCz
    }
  }, [_c('img', {
    staticClass: "img-spe2",
    attrs: {
      "src": require("../../assets/chart5-icon/Bolus.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('t1112_Manual_Bolus_or_Modified_Bolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe5",
    class: {
      'zh12': !_vm.isEn, 'it11': _vm.isIt, 'po12': _vm.isPo, 'du12': _vm.isDu, 'cz12': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/chart5-icon/New Patch .png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe6",
    class: {
      'zh13': !_vm.isEn, 'it12': _vm.isIt, 'po13': _vm.isPo, 'du13': _vm.isDu, 'cz13': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/chart5-icon/Others.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Others')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe4",
    class: {
      'zh11': !_vm.isEn, 'it13': _vm.isIt, 'po14': _vm.isPo, 'du14': _vm.isDu
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/chart5-icon/Exercise.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh9': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/chart5-icon/Mutiple Readings.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Multiple BG Readings')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/早餐.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/中餐.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/晚餐.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/零食.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Snack')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/进入自动模式.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Auto Mode On')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn, 'es16': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/退出自动模式.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Auto Mode Off')))])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-319633ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print-htmplate/quickPrint5.vue
// module id = 1450
// module chunks = 7